import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map } from 'rxjs/operators';

import { entityActividadesGrupoEspecieAddSuccess } from '../entity-actividades-grupo-especie/entity-actividades-grupo-especie.actions';
import { entityComercializacionesAddSuccess } from '../entity-comercializaciones/comercializaciones.actions';
import { entityDepositosAddSuccess } from '../entity-depositos/depositos.actions';
import {
  entityLaboratoriosAddSuccess,
  entityLaboratoriosLoadFailure
} from '../entity-laboratorios/laboratorios.actions';
import { entityRPESubActividadesAddSuccess } from '../entity-rpe-sub-actividades/rpe-sub-actividades.actions';

import { entityStepperNext } from './stepper.actions';
import { entityPersonasFisicaAddSuccess, entityPersonasFisicaChangeSuccess } from '../../empresas/entity-personas-fisica/entity-personas-fisica.actions';
import { entityPersonasJuridicaAddSuccess, entityPersonasJuridicaChangeSuccess } from '../../empresas/entity-personas-juridica/entity-personas-juridica.actions';
import { entityIntegranteAddSuccess } from '../../roles/entity-integrante/entity-integrante.actions';
import { entitySitiosProcesamientoAddSuccess } from '../entity-sitios-procesamiento/sitios-procesamiento.actions';

@Injectable()
export class StepperEffects {
  // load
  preNextStep = createEffect(() =>
    this.actions$.pipe(
      ofType(
        //entityDepositosAddSuccess, entityActividadesGrupoEspecieAddSuccess,
        //entityLaboratoriosAddSuccess, entitySitiosProcesamientoAddSuccess,
        //entityComercializacionesAddSuccess, entityRPESubActividadesAddSuccess,
        entityPersonasFisicaAddSuccess,
        entityPersonasJuridicaAddSuccess,
        entityPersonasFisicaChangeSuccess,
        entityPersonasJuridicaChangeSuccess,
        //,entityIntegranteAddSuccess
      ),
      map(() => entityStepperNext())
    )
  );

  constructor(private actions$: Actions) {}
}
